import React, { useState } from "react";
import { KYCIcon } from "../../../asset/icons";
import {
    ArrowDown2,
    ShieldTick,
    Global,
    Card,
    DocumentText,
    Personalcard,
    Car,
    UserTick,
    PasswordCheck,
    DiscountCircle,
} from "iconsax-reactjs";
import { useNavigate } from "react-router-dom";

function IconBubble({ children, bg = "#E8EAF7" }) {
    return (
        <span
            className="inline-grid place-items-center w-9 h-9 rounded-full"
            style={{ backgroundColor: bg }}
        >
            {children}
        </span>
    );
}

function DotFileIcon() {
    return (
        <IconBubble>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                    d="M14 3H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9l-6-6Z"
                    stroke="#6B7280"
                    strokeWidth="1.5"
                />
                <path d="M14 3v6h6" stroke="#6B7280" strokeWidth="1.5" />
            </svg>
        </IconBubble>
    );
}

const sections = [
    {
        n: "1",
        title: "Control person/UBO information",
        items: [
            {
                label: "National Identification Number",
                icon: UserTick,
                color: "#6F739B",
                bg: "#E8EAF7",
            },
            {
                label: "Bank Verification Number",
                icon: PasswordCheck,
                color: "#6F739B",
                bg: "#E8EAF7",
            },
            {
                label: "Tax Identification Number",
                icon: DiscountCircle,
                color: "#6F739B",
                bg: "#E8EAF7",
            },
        ],
    },
    {
        n: "2",
        title: "Valid IDs",
        note: "You’ll only need to provide one of these",
        items: [
            { label: "Passport", icon: Global, color: "#6F739B", bg: "#E8EAF7" },
            { label: "NIN Slip", icon: DocumentText, color: "#6F739B", bg: "#E8EAF7" },
            { label: "National ID", icon: Personalcard, color: "#6F739B", bg: "#E8EAF7" },
            { label: "Driver’s Licence", icon: Car, color: "#6F739B", bg: "#E8EAF7" },
            { label: "Voter’s card", icon: Card, color: "#6F739B", bg: "#E8EAF7" },
        ],
    },
    {
        n: "3",
        title: "Financial information",
        items: [
            {
                label: "Transaction volume",
                icon: DocumentText,
                color: "#6F739B",
                bg: "#E8EAF7",
            },
            {
                label: "Proof of source of funds e.g. bank statement",
                icon: DocumentText,
                color: "#6F739B",
                bg: "#E8EAF7",
            },
        ],
    },
];

function UpdateKYC() {
    const [openIdx, setOpenIdx] = useState(-1);
    const navigate = useNavigate();

    const onClose = () => navigate(-1);
    const onContinue = () => navigate("/update-kyc/control-person");
    const toggle = (idx) => setOpenIdx((curr) => (curr === idx ? -1 : idx));

    return (
        <div className="grid place-items-center md:px-4">
            <div className="w-full max-w-[700px]">
                {/* Header */}
                <div className="p-6 pb-8">
                    <div className="mx-auto grid place-items-center">
                        <KYCIcon />
                    </div>
                    <h2 className="aku-heading-h2-medium text-[#101828] text-center">
                        We need additional information to open your USD wallet.
                    </h2>
                </div>

                {/* Body */}
                <div className="md:px-6 pb-2">
                    <div className="rounded-2xl bg-[#fff] overflow-hidden">
                        {sections.map((sec, idx) => {
                            const open = openIdx === idx;
                            return (
                                <div key={sec.n} className="border-t border-[#EEF0F4]">
                                    <button
                                        type="button"
                                        onClick={() => toggle(idx)}
                                        aria-expanded={open}
                                        className="w-full px-4 py-3 flex items-center justify-between"
                                    >
                                        <div className="flex items-center gap-3">
                                            <span className="h-8 w-8 grid place-items-center rounded-full border border-[#E4E7EC] text-[#6B7280] text-sm">
                                                {sec.n}
                                            </span>
                                            <span className="font-[450] text-[16px] text-[#4F5372]">
                                                {sec.title}
                                            </span>
                                        </div>
                                        <ArrowDown2
                                            size={20}
                                            className={`transition-transform ${
                                                open ? "rotate-180" : ""
                                            }`}
                                        />
                                    </button>

                                    <div
                                        className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${
                                            open
                                                ? "grid-rows-[1fr] opacity-100"
                                                : "grid-rows-[0fr] opacity-0"
                                        }`}
                                    >
                                        <div className="overflow-hidden">
                                            <div className="ml-16 mr-6 rounded-xl bg-[#F7F9FC]">
                                                <ul className="space-y-4 p-3">
                                                    {sec.items.map((it, i) => {
                                                        const Icon = it.icon;
                                                        return (
                                                            <li
                                                                key={i}
                                                                className="flex items-center justify-between"
                                                            >
                                                                <div className="flex items-center gap-3">
                                                                    {Icon ? (
                                                                        <IconBubble bg={it.bg}>
                                                                            <Icon
                                                                                size={18}
                                                                                color={
                                                                                    it.color ||
                                                                                    "#6B7280"
                                                                                }
                                                                            />
                                                                        </IconBubble>
                                                                    ) : (
                                                                        <DotFileIcon />
                                                                    )}
                                                                    <span className="text-[#161827] text-[14px] font-[350]">
                                                                        {it.label}
                                                                    </span>
                                                                </div>
                                                                {it.badge && (
                                                                    <span className="text-xs px-3 py-1 rounded-full bg-[#E8EAF7] border text-[#4F5372]">
                                                                        {it.badge}
                                                                    </span>
                                                                )}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                                {sec.note && (
                                                    <p className="px-3 pb-3 text-[#4F5372] text-[14px] italic">
                                                        {sec.note}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        {/* Privacy note */}
                        <div className="px-4 py-4 flex items-start gap-3">
                            <ShieldTick
                                variant="Bold"
                                color="#356AFC"
                                size={26}
                                className="shrink-0"
                            />
                            <div className="text-sm text-[#475467]">
                                Your information is handled securely, in line with our{" "}
                                <a
                                    className="underline font-medium"
                                    href="/privacy"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Privacy Policy
                                </a>
                                .
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-end gap-3 px-6 py-4">
                    <button
                        className="px-4 py-2 rounded-lg text-[#383B56] hover:bg-[#f7f7f7]"
                        onClick={onClose}
                    >
                        Do it later
                    </button>
                    <button
                        className="px-4 py-2 rounded-lg bg-[#6F00FF] text-white hover:bg-[#5A00D6]"
                        onClick={onContinue}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UpdateKYC;
